export const COUNTRY = 'COUNTRY';
export const SHOW_APP_LOADER = "SHOW_APP_LOADER"
export const HIDE_APP_LOADER = "HIDE_APP_LOADER"
export const USER_INITIATE = "USER_INITIATE"
export const SIGN_IN = "SIGN_IN"
export const UPDATE_DATA = "UPDATE_DATA"
export const EMAIL = "EMAIL"
export const PASSWORD = "PASSWORD"
export const LOGIN_TOKEN = "LOGIN_TOKEN"
export const REMEMBER_ME = "REMEMBER_ME"
export const LOCAL_STORE_DATA = "LOCAL_STORE_DATA"
export const INVOICE_DATA = "INVOICE_DATA";
export const INVOICE_DOWNLOAD = "INVOICE_DOWNLOAD"
